/*eslint-disable*/
import * as React from "react";

export function formatDate(date) {
if(date){
  const [yyyy, mm, dd] = date.split("-");
  return `${dd}/${mm}/${yyyy}`;
}
}
